// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 1200 48%27 preserveAspectRatio=%27none%27%3E%3Cpath d=%27M0,24 C200,0 400,48 600,24 C800,0 1000,48 1200,24 L1200,0 L0,0 Z%27 fill=%27%23ffffff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styles - أنماط التذييل */
.footer {
  background: var(--gradient-primary);
  color: var(--bg-white);
  padding: 70px 0 20px;
  margin-top: 80px;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 0;
  width: 200%;
  height: 48px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 50% 100%;
  background-repeat: repeat-x;
  opacity: 0.14;
  animation: footerWave 22s linear infinite;
  pointer-events: none;
}

@keyframes footerWave {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.dark-mode .footer::before {
  opacity: 0.08;
}

@media (prefers-reduced-motion: reduce) {
  .footer::before {
    animation: none;
  }
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
  margin-bottom: 2rem;
}

.footer-section h3,
.footer-section h4 {
  color: var(--bg-white);
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
}

.footer-section h4 {
  font-size: 1.1rem;
}

.footer-section p {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.8;
  margin-bottom: 0.5rem;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 0.8rem;
  color: rgba(255, 255, 255, 0.9);
  transition: color 0.3s ease;
  line-height: 1.6;
}

/* تحسين عرض أرقام الهواتف */
.footer-section ul li span[dir="ltr"] {
  display: inline-block;
  direction: ltr;
  text-align: left;
  unicode-bidi: embed;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
  margin: 0 2px;
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.9);
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: var(--secondary-light-gold);
}

/* Social Media Icons - أيقونات وسائل التواصل */
.social-media {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  background-color: var(--secondary-light-gold);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(212, 175, 55, 0.3);
}

/* Footer Bottom - أسفل التذييل */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 2rem;
  text-align: center;
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-size: 0.9rem;
}

/* Responsive Design - التصميم المتجاوب */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 15px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .social-media {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-section h3,
  .footer-section h4 {
    font-size: 1.1rem;
  }

  .social-icon {
    width: 40px;
    height: 40px;
    font-size: 1.3rem;
  }
}

/* Dark Mode - الوضع الداكن */
.dark-mode .footer {
  background: linear-gradient(135deg, #1a202c 0%, #2d3748 50%, #1a202c 100%);
  border-top: 1px solid var(--border-light);
}

`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,mCAAmC;EACnC,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAoP;EACpP,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE,0EAA0E;EAC1E,yCAAyC;AAC3C","sourcesContent":["/* Footer Styles - أنماط التذييل */\n.footer {\n  background: var(--gradient-primary);\n  color: var(--bg-white);\n  padding: 70px 0 20px;\n  margin-top: 80px;\n  position: relative;\n  overflow: hidden;\n}\n\n.footer::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: 0;\n  width: 200%;\n  height: 48px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 48' preserveAspectRatio='none'%3E%3Cpath d='M0,24 C200,0 400,48 600,24 C800,0 1000,48 1200,24 L1200,0 L0,0 Z' fill='%23ffffff'/%3E%3C/svg%3E\");\n  background-size: 50% 100%;\n  background-repeat: repeat-x;\n  opacity: 0.14;\n  animation: footerWave 22s linear infinite;\n  pointer-events: none;\n}\n\n@keyframes footerWave {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n.dark-mode .footer::before {\n  opacity: 0.08;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .footer::before {\n    animation: none;\n  }\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2.5rem;\n  margin-bottom: 2rem;\n}\n\n.footer-section h3,\n.footer-section h4 {\n  color: var(--bg-white);\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n}\n\n.footer-section h4 {\n  font-size: 1.1rem;\n}\n\n.footer-section p {\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.8;\n  margin-bottom: 0.5rem;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: 0.8rem;\n  color: rgba(255, 255, 255, 0.9);\n  transition: color 0.3s ease;\n  line-height: 1.6;\n}\n\n/* تحسين عرض أرقام الهواتف */\n.footer-section ul li span[dir=\"ltr\"] {\n  display: inline-block;\n  direction: ltr;\n  text-align: left;\n  unicode-bidi: embed;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 0.5px;\n  margin: 0 2px;\n}\n\n.footer-section ul li a {\n  color: rgba(255, 255, 255, 0.9);\n  transition: color 0.3s ease;\n}\n\n.footer-section ul li a:hover {\n  color: var(--secondary-light-gold);\n}\n\n/* Social Media Icons - أيقونات وسائل التواصل */\n.social-media {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.social-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 45px;\n  height: 45px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  font-size: 1.5rem;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.social-icon:hover {\n  background-color: var(--secondary-light-gold);\n  transform: translateY(-3px);\n  box-shadow: 0 5px 15px rgba(212, 175, 55, 0.3);\n}\n\n/* Footer Bottom - أسفل التذييل */\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  padding-top: 2rem;\n  text-align: center;\n}\n\n.footer-bottom p {\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n/* Responsive Design - التصميم المتجاوب */\n@media (max-width: 768px) {\n  .footer {\n    padding: 40px 0 15px;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    text-align: center;\n  }\n\n  .social-media {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-section h3,\n  .footer-section h4 {\n    font-size: 1.1rem;\n  }\n\n  .social-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1.3rem;\n  }\n}\n\n/* Dark Mode - الوضع الداكن */\n.dark-mode .footer {\n  background: linear-gradient(135deg, #1a202c 0%, #2d3748 50%, #1a202c 100%);\n  border-top: 1px solid var(--border-light);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
